import { Component, OnInit, OnDestroy } from '@angular/core';
import { Globals } from '../../globals';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-library',
    templateUrl: './library.component.html',
    styleUrls: ['./library.component.css']
})
export class LibraryComponent implements OnInit, OnDestroy {

    public connect;
    public library = { data: [], listImages: [], listVideo: [] };
    private type = [
        { title: 'all', show: true, filter: '*' },
        { title: 'images', show: true, filter: 1 },
        { title: 'video', show: true, filter: 2 },
    ];
    public token: any = {
        getLibrary: "api/getLibrary"
    }
    constructor(
        public globals: Globals,
        public sanitizer: DomSanitizer
    ) {
        setTimeout(() => {
            window["test"]();
            window["viewLibrary"]();
        }, 1000);
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "getlibrary":
                    this.library.data = res.data;
                    this.library.data.reduce((n, o, i) => {
                        o.value = (o.type == 2) ? this.sanitizer.bypassSecurityTrustResourceUrl(o.value.replace('watch?v=', 'embed/')) : o.value;
                        let type = (o.type == 2) ? this.library.listVideo.push(o) : this.library.listImages.push(o);
                        return n;
                    }, [])
                    break;
                default:
                    break;
            }
        })
    }

    ngOnInit() {
        this.globals.send({ path: this.token.getLibrary, token: "getlibrary" })
    }
    ngOnDestroy() {
        this.connect.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/frontend/library/library.component.ts